var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createLayout = function (options) {
    var _a, _b, _c, _d;
    if (options === void 0) { options = {}; }
    return (__assign({ 
        // support 3rd party banners like heroku,
        appTop: ((_a = options.tokens) === null || _a === void 0 ? void 0 : _a.size_layout_app_top) || 0, appBarHeight: ((_b = options.tokens) === null || _b === void 0 ? void 0 : _b.size_layout_app_bar_height) || 56, sidebarWidth: ((_c = options.tokens) === null || _c === void 0 ? void 0 : _c.size_layout_sidebar_width) || 265, sidebarWidthCollapsed: ((_d = options.tokens) === null || _d === void 0 ? void 0 : _d.size_layout_sidebar_width_collapsed) || 68 }, options));
};
